import { Environment } from 'relay-runtime';
import { getDefaultRelayEnvironmentConfig } from '@atlassian/relay-environment-config';
export default new Environment(getDefaultRelayEnvironmentConfig({}));